// src/pages/ForgotPasswordPage.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css'; // ponovno uporabljamo že obstoječe stile

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!email) {
      setError('Prosimo, vnesite svoj email.');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
        credentials: 'include',
      });
      const data = await response.json();

      if (response.ok) {
        setSuccess(
          'Če je ta email registriran, boste v nekaj trenutkih prejeli povezavo za ponastavitev gesla.'
        );
        // Počakamo par sekund in nato preusmerimo nazaj na prijavo
        setTimeout(() => navigate('/prijava'), 4000);
      } else {
        setError(data.message || 'Prišlo je do napake. Poskusite kasneje.');
      }
    } catch {
      setError('Ni mogoče vzpostaviti povezave s strežnikom. Poskusite kasneje.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg">
      <section className="sign_in_area pt-120 pb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5 col-md-7 col-sm-9">
              <div className="sign_in_form">
                <div className="sign_title">
                  <h5 className="title">Pozabljeno geslo</h5>
                </div>

                {error && <div className="alert alert-danger">{error}</div>}
                {success && <div className="alert alert-success">{success}</div>}

                {!success && (
                  <form onSubmit={handleSubmit}>
                    <div className="sign_form_wrapper">
                      <div className="single_form">
                        <input
                          type="email"
                          placeholder="Vnesite svoj email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                        <i className="fa fa-envelope input-icon-left"></i>
                      </div>

                      <div className="single_form">
                        <button
                          type="submit"
                          className="btn btn-success post-item-navbar-btn"
                          disabled={loading}
                        >
                          {loading ? 'Pošiljam...' : 'Pošlji povezavo'}
                        </button>
                      </div>
                    </div>
                  </form>
                )}

                <div className="text-center mt-3">
                  <small>
                    Spomnite se gesla?{' '}
                    <button
                      className="btn btn-link p-0"
                      type="button"
                      onClick={() => navigate('/prijava')}
                      style={{ textDecoration: 'none' }}
                    >
                      Prijava
                    </button>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForgotPasswordPage;